/**
 * Direct PUT to a signed GCS URL. Lives in `infrastructure/api/` so feature
 * code doesn't reach for `fetch` directly. Throws on non-2xx so callers can
 * surface an upload-failure status to the user.
 */

/**
 * A failed GCS upload PUT. Carries the HTTP `status` (undefined for network
 * failures) so the upload orchestrator can tell transient errors (5xx, 429,
 * 408, network) — worth retrying — from deterministic ones (4xx like a bad or
 * expired signed URL) that should fail fast.
 */
class GcsUploadError extends Error {
  readonly status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = "GcsUploadError";
    this.status = status;
  }
}

export async function uploadFileToSignedUrl(
  file: File,
  signedUrl: string,
  signal?: AbortSignal,
): Promise<void> {
  const response = await fetch(signedUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
    signal,
  });
  if (!response.ok) {
    throw new GcsUploadError(`Upload failed: ${response.status}`, response.status);
  }
}
